import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      href="http://e-gam.com/GKA/Privacy%20Policy.pdf"
      className="d-block text-white  px-3 py-2 rounded mb-2 hover-link "
    >
      Privacy Policy
    </div>
  );
};

export default PrivacyPolicy;
